const handleNormalFlexPrice = (totalSquareFeet: number): number => {
    if (totalSquareFeet <= 10) {
        return 350;
    } else if (totalSquareFeet > 10 && totalSquareFeet <= 16) {
        return 450;
    } else if (totalSquareFeet > 16 && totalSquareFeet <= 24) {
        return 550;
    } else if (totalSquareFeet > 24 && totalSquareFeet <= 32) {
        return 650;
    } else if (totalSquareFeet > 32 && totalSquareFeet <= 40) {
        return 750;
    } else if (totalSquareFeet > 40 && totalSquareFeet <= 50) {
        return 850;
    } else if (totalSquareFeet > 50 && totalSquareFeet <= 60) {
        return 950;
    } else if (totalSquareFeet > 60 && totalSquareFeet <= 70) {
        return 1050;
    } else if (totalSquareFeet > 70 && totalSquareFeet <= 80) {
        return 1100;
    } else if (totalSquareFeet > 80 && totalSquareFeet <= 91) {
        return 1200;
    } else if (totalSquareFeet > 91 && totalSquareFeet <= 100) {
        return 1300
    }
    return 0;
};

const handleStarFlexPrice = (totalSquareFeet: number): number => {
    if (totalSquareFeet <= 10) {
        return 450;
    } else if (totalSquareFeet > 10 && totalSquareFeet <= 16) {
        return 750;
    } else if (totalSquareFeet > 16 && totalSquareFeet <= 25) {
        return 1200;
    } else if (totalSquareFeet > 25 && totalSquareFeet <= 30) {
        return 1400;
    }
    return 0;
};

export {
    handleNormalFlexPrice,
    handleStarFlexPrice
}